(function () {
  function updateFacade(select) {
    var facade = select.parentElement.querySelector('.wss-pdp-select-facade');
    if (!facade) return;
    var option = select.selectedOptions[0];
    if (!option) return;
    var root = select.closest('product-info');
    var label = (root && root.dataset.wssLowStockLabel) || 'Low Stock';
    facade.querySelector('.wss-pdp-select-facade__value').textContent = option.textContent.trim();
    facade.querySelector('.wss-pdp-select-facade__stock').textContent = option.dataset.wssLow === 'true' ? label : '';
  }

  function initSelects(root) {
    root.querySelectorAll('.product-form__input--dropdown .select').forEach(function (wrap) {
      if (wrap.querySelector('.wss-pdp-select-facade')) return;
      var select = wrap.querySelector('select.select__select');
      if (!select) return;
      var facade = document.createElement('span');
      facade.className = 'wss-pdp-select-facade';
      facade.innerHTML =
        '<span class="wss-pdp-select-facade__value"></span><span class="wss-pdp-select-facade__stock"></span>';
      wrap.appendChild(facade);
      select.addEventListener('change', function () {
        updateFacade(select);
      });
      updateFacade(select);
    });
  }

  function initTrackpadGallery(productInfo) {
    var viewer = productInfo.querySelector('media-gallery slider-component[id^="GalleryViewer"]');
    if (!viewer || viewer.dataset.wssTrackpadGallery === 'true') return;

    var slider = viewer.querySelector('.product__media-list');
    if (!slider) return;

    viewer.dataset.wssTrackpadGallery = 'true';
    slider.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 1) return;
        event.preventDefault();
        slider.scrollLeft += event.deltaX;
      },
      { passive: false }
    );
  }

  function watch(productInfo) {
    initSelects(productInfo);
    initTrackpadGallery(productInfo);
    new MutationObserver(function () {
      initSelects(productInfo);
      initTrackpadGallery(productInfo);
    }).observe(productInfo, { childList: true, subtree: true });
  }

  function start() {
    document.querySelectorAll('product-info.wss-pdp').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
